theme.headerSticky = (function() {
  function ScrollSticky(e){
    const headerStickyWrapper = document.querySelector('header');
    const headerStickyTarget = document.querySelector('.header__sticky');
    const trustbar = document.querySelector('[class*="trustbar-"]');

    function setTrustbarOffset(){
      var h = trustbar ? trustbar.offsetHeight : 0;
      document.documentElement.style.setProperty('--trustbar-offset', h + 'px');
    }

    if(trustbar){
      setTrustbarOffset();
      window.addEventListener('resize', setTrustbarOffset);
    }

    if(headerStickyTarget){
      /* DreamPrices 2026-09-07 - rattat av Claude.

         FORUT: klassen .sticky lades pa forst nar man scrollat forbi hela
         headern (window.scrollY > headerHeight, dvs 162 px pa desktop och
         89 px pa mobil). Under de forsta 162 pixlarna scrollade menyn bort
         helt och kom sedan tillbaka med en 0,7 s fadeInDown-animation.
         Det var det som upplevdes som att menyn inte hanger med.

         DESSUTOM: nar headern blev position:fixed lamnade den ett tomrum i
         dokumentflodet, sa allt innehall under hoppade upp 162 px i samma
         ogonblick. Det bidrog till layoutforskjutningen som syns i
         Shopifys hastighetsrapport.

         NU: troskeln ar 8 px, sa menyn fastnar direkt nar man borjar scrolla,
         och wrapperns hojd reserveras med min-height sa ingenting hoppar.
         Animationen stangs av i assets/component-header-sticky-offset.css.

         De tva doda variablerna StickyTargetElement och TargetElementTopOffset
         (som anropade TopOffset utan att anvanda resultatet) ar borttagna. */

      var troskel = 8;
      var reserverad = 0;

      function matHojd(){
        if(!headerStickyTarget.classList.contains('sticky')){
          reserverad = headerStickyTarget.offsetHeight;
        }
      }

      matHojd();

      window.addEventListener('resize', function(){
        if(headerStickyTarget.classList.contains('sticky')){
          return;
        }
        matHojd();
      });

      function uppdatera(){
        if(window.scrollY > troskel){
          if(!headerStickyTarget.classList.contains('sticky')){
            if(!reserverad){
              reserverad = headerStickyTarget.offsetHeight;
            }
            headerStickyWrapper.style.minHeight = reserverad + 'px';
            headerStickyTarget.classList.add('sticky');
          }
        } else if(headerStickyTarget.classList.contains('sticky')){
          headerStickyTarget.classList.remove('sticky');
          headerStickyWrapper.style.minHeight = '';
        }
      }

      window.addEventListener('scroll', uppdatera, { passive: true });
      uppdatera();
    }


  }
  return ScrollSticky;
})();


